import LICENSE_KEY_FORM_REQUEST from "./license-key-request-form.graphql";
import SPONSORSHIP_FORM_REQUEST from "./sponsorship-request-form.graphql";
import REQUEST_CONTACT from "./request-contact.graphql";

const contactService = ({ gqlClient }) => {
	const requestLicenseKeyForm = request =>
		gqlClient(LICENSE_KEY_FORM_REQUEST, { request }).then(result => result.requestLicenseKeyForm);

	const requestSponsorshipForm = request =>
		gqlClient(SPONSORSHIP_FORM_REQUEST, { request }).then(result => result.requestSponsorshipForm);

	const requestContact = (input, turingToken, turingType) =>
		gqlClient(
			REQUEST_CONTACT,
			{ input },
			{ headers: { "x-turing-token": turingToken, "x-turing-type": turingType } },
		).then(result => result.requestContact);

	return { requestLicenseKeyForm, requestSponsorshipForm, requestContact };
};

export default contactService;
